import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../../lib/api';
import Icon from '../../components/AppIcon';

const InstagramCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing');
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const errorParam = searchParams.get('error');

    if (errorParam) {
      setStatus('error');
      setError(searchParams.get('error_description') || 'Instagram authorization was denied.');
      return;
    }

    if (!code || !state) {
      setStatus('error');
      setError('Missing authorization code. Please try again from the Settings page.');
      return;
    }

    const token = localStorage.getItem('ourday_token') || localStorage.getItem('admin_token');
    if (!token) {
      setStatus('error');
      setError('Not logged in. Please log in and try again.');
      return;
    }

    api.instagramCallback(code, state, token)
      .then(() => {
        setStatus('success');
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      })
      .catch((err) => {
        setStatus('error');
        setError(err.message);
      });
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="bg-card rounded-2xl shadow-romantic-lg border border-border p-8 max-w-md w-full text-center">
        {status === 'processing' && (
          <>
            <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-6" />
            <h2 className="text-xl font-bold text-foreground mb-2">Connecting Instagram...</h2>
            <p className="text-muted-foreground text-sm">Please wait while we finish linking your account.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="CheckCircle" size={32} />
            </div>
            <h2 className="text-xl font-bold text-foreground mb-2">Instagram Connected!</h2>
            <p className="text-muted-foreground text-sm">Redirecting you back to Settings...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-16 h-16 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <Icon name="XCircle" size={32} />
            </div>
            <h2 className="text-xl font-bold text-foreground mb-2">Connection Failed</h2>
            <p className="text-red-500 text-sm mb-6">{error}</p>
            <button
              onClick={() => navigate('/dashboard')}
              className="px-6 py-2.5 bg-primary text-white rounded-xl font-bold hover:bg-primary/90 transition-colors"
            >
              Back to Settings
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default InstagramCallback;
